import { useTranslation } from 'react-i18next'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100]

interface PageSizeSelectProps {
  value: number
  onChange: (value: number) => void
}

export function PageSizeSelect({ value, onChange }: PageSizeSelectProps) {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-2">
      <span style={{ fontSize: 12, color: 'var(--ad-text-muted)', whiteSpace: 'nowrap' }}>
        {t('common.perPage')}
      </span>
      <Select value={String(value)} onValueChange={(v) => onChange(Number(v))}>
        <SelectTrigger className="h-8 w-20 text-sm">
          <SelectValue>{value}</SelectValue>
        </SelectTrigger>
        <SelectContent>
          {PAGE_SIZE_OPTIONS.map((n) => (
            <SelectItem key={n} value={String(n)}>{n}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
